import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {BidDTO, User} from "../../../../../global/interfaces";
import {CustomerService, LoggerService, UserService} from "../../../../../global/services";
import {} from "../../../../../global/enums";

@Component({
  selector: 'app-seller-hub-bids-received',
  templateUrl: './seller-hub-bids-received.component.html',
  styleUrls: ['./seller-hub-bids-received.component.scss']
})
export class SellerHubBidsReceivedComponent implements OnInit {

  constructor(private userService: UserService,
              private customerService: CustomerService,
              private router: Router,
              private logService: LoggerService) {
  }

  logger = this.logService.taggedLogger(this.constructor?.name);

  isLoading: boolean;
  bids: BidDTO[];
  user: User;

  async ngOnInit() {

    await this.userService.loadCurrentUser().then(() => {
      this.user = this.userService.CurrentUser;
    });

    this.loadBids();
  }

  loadBids() {

    this.isLoading = true;

    const contactId = this.user.contactId;
    const customerId = this.user.customerId;

    this.customerService.getBidsReceived(customerId).then(result => {
      this.bids = result;
      this.isLoading = false;

      this.logger.info("Loaded bids: ", this.bids);
    });
  }
}
